import { render, staticRenderFns } from "./ImprovementForm.vue?vue&type=template&id=b5b2242e&scoped=true"
import script from "./ImprovementForm.vue?vue&type=script&lang=js"
export * from "./ImprovementForm.vue?vue&type=script&lang=js"
import style0 from "./ImprovementForm.vue?vue&type=style&index=0&id=b5b2242e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b2242e",
  null
  
)

export default component.exports